var exports = {
  "p_": "x4ddf2309--7b1853--list",
  "AS": "x4ddf2309--7b1853--item",
  "UE": "x4ddf2309--7b1853--arrow",
  "nf": "x4ddf2309--7b1853--link",
};

module.exports = exports;
